

exports.__esModule = true;
exports.$incontextFallback = $incontextFallback;

var _angular = require('angular');

function $incontextFallback(win, url) {

    _angular.$rootScope.$emit('loading');

    window.onbeforeunload = function () {};
    window.onunload = function () {};

    var parent = window.opener || window.parent;

    if (!window.paypalCheckout.props.fallback) {
        parent.location = url;
        win.close();
        return;
    }

    try {

        var frame;

        try {
            if (typeof parent.onLegacyFallback === 'function') {
                frame = parent;
            }
        } catch (err) {
            // pass
        }

        if (!frame) {
            for (var i = 0; i < parent.frames.length; i++) {

                try {
                    if (typeof parent.frames[i].onLegacyFallback === 'function') {
                        frame = parent.frames[i];
                        break;
                    }
                } catch (err) {
                    // pass
                }
            }
        }

        if (!frame) {
            parent.location = url;
            win.close();
            return;
        }

        frame.onLegacyFallback(win);

        window.addEventListener('unload', function () {

            var width = 970;
            var height = 900;
            var left = void 0;
            var top = void 0;

            if (window.outerWidth) {
                left = Math.round((window.outerWidth - width) / 2) + window.screenX;
                top = Math.round((window.outerHeight - height) / 2) + window.screenY;
            } else if (window.screen.width) {
                left = Math.round((window.screen.width - width) / 2);
                top = Math.round((window.screen.height - height) / 2);
            }

            window.resizeTo(width, height);
            window.moveTo(left, top);
        });

        win.location = url;
    } catch (err) {

        parent.location = url;
        win.close();
    }

    window.paypalCheckout.props.fallback(url);
}

angular.value("$incontextFallback", $incontextFallback);
_angular.$rootScope;


//////////////////
// WEBPACK FOOTER
// ./js/lib/icFallback.js
// module id = ./js/lib/icFallback.js
// module chunks = 1